import { useCallback, useMemo } from 'react'

import { useAppDispatch, useAppSelector } from 'redux/toolkit/hooks'
import { switchToOldUi } from 'redux/features/auth/authSlice'
import { AvailableSettings, SettingValue } from 'types/Settings'
import { useUiSwitcherRights } from 'components/libs/userRights/libs/useUiSwitcherRights'
import routesConfig from 'lib/routesConfig'

export interface State {
  show: boolean
}

export interface EventHandlers {
  onSwitchToOldUi: () => void
}

export const useUiSwitcherLogic = (): [State, EventHandlers] => {
  const dispatch = useAppDispatch()

  const { activePath, features } = useAppSelector(_store => ({
    activePath: _store.app.activePath,
    features: _store.auth.accessTokenObject?.features
  }))

  const onSwitchToOldUi = useCallback(
    () => dispatch(switchToOldUi({ [AvailableSettings.REACT_OPT_IN]: SettingValue.DISABLED })),
    [dispatch]
  )

  const { canViewPhaseOneFeature } = useUiSwitcherRights()

  return useMemo(
    () => [
      {
        show: !!canViewPhaseOneFeature && activePath.id !== routesConfig.EMAIL_LOG?.id && !!features?.isTdfToggleVisible
      },
      {
        onSwitchToOldUi
      }
    ],
    [activePath, canViewPhaseOneFeature, onSwitchToOldUi, features]
  )
}
